
import { IClientsTreeNode } from "../components/Administration/context/shared";
import { Account } from "../shared/generated";

export const getNodeByKey = (key: string, treeNode: IClientsTreeNode[] | undefined | null): IClientsTreeNode | null => {
    let returnNode: IClientsTreeNode | null = null;
    if (!treeNode)
        return null;
    for (let i = 0; i < treeNode.length; i++) {
        const node = treeNode[i];
        if (node.key && node.key == key) {
            returnNode = node;
            break;
        } else if (getNodeByKey(key, node.children as IClientsTreeNode[])) {
            returnNode = getNodeByKey(key, node.children as IClientsTreeNode[]);
            break;
        }
    }
    return returnNode;
};
export const findAccountNodeByLoginAndClient = (login, clientId, treeNode) => {
    let returnNode;
    if (!treeNode)
        return null;
    for (let i = 0; i < treeNode.length; i++) {
        const node = treeNode[i];
        if (node.parentId == clientId && node.name == login) {
            returnNode = node;
        } else if (findAccountNodeByLoginAndClient(login, clientId, node.children)) {
            returnNode = findAccountNodeByLoginAndClient(login, clientId, node.children);
        }
    }
    return returnNode;
};
export const findClientNodeByName = (name: string, treeNode: IClientsTreeNode[]): IClientsTreeNode | null => {
    let returnNode: IClientsTreeNode | null = null;
    if (!treeNode)
        return null;
    for (let i = 0; i < treeNode.length; i++) {
        const node = treeNode[i];
        if (node.type === 'client' && node.name === name) {
            returnNode = node;
            break;
        } else if (findClientNodeByName(name, node.children as IClientsTreeNode[])) {
            returnNode = findClientNodeByName(name, node.children as IClientsTreeNode[]);
            break;
        }
    }
    return returnNode;
};
export const getClientNodeById = (id: string, treeNode: IClientsTreeNode[]): IClientsTreeNode | null => {
    let returnNode: IClientsTreeNode | null = null;
    if (!treeNode)
        return null;
    for (let i = 0; i < treeNode.length; i++) {
        const node = treeNode[i];
        if (node.id && node.id == id) {
            returnNode = node;
            break;
        } else if (getClientNodeById(id, node.children as IClientsTreeNode[])) {
            returnNode = getClientNodeById(id, node.children as IClientsTreeNode[]);
            break;
        }
    }
    return returnNode;
}
export const getAccountNode = (account: Account, treeNode: IClientsTreeNode[]): IClientsTreeNode | null => {
    let returnNode: IClientsTreeNode | null = null;
    if (!treeNode)
        return null;
    for (let i = 0; i < treeNode.length; i++) {
        const node = treeNode[i];
        if (node.parentId && node.parentId === account.ClientId && node.name && node.name === account.Login) {
            returnNode = node;
            break;
        } else if (getAccountNode(account, node.children as IClientsTreeNode[])) {
            returnNode = getAccountNode(account, node.children as IClientsTreeNode[]);
            break;
        }
    }
    return returnNode;
}
export interface IFoundAccountNode {
    account: IClientsTreeNode;
    client: IClientsTreeNode | null;
}
export const searchAccountsInTree = (query: string, treeNode: IClientsTreeNode[] | undefined | null): IFoundAccountNode[] => {
    const result: IFoundAccountNode[] = [];
    if (!treeNode || !query)
        return result;
    const normalizedQuery = query.trim().toLowerCase();
    if (!normalizedQuery)
        return result;
    const walk = (nodes: IClientsTreeNode[], parentClient: IClientsTreeNode | null) => {
        for (const node of nodes) {
            if (node.type === 'client')
                parentClient = node;
            if (node.name && node.name.toLowerCase().includes(normalizedQuery) && node.type !== 'client') {
                result.push({ account: node, client: parentClient });
            }
            if (node.children?.length)
                walk(node.children as IClientsTreeNode[], parentClient);
        }
    }
    walk(treeNode, null);
    return result;
}